/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import perform from "mutation/perform";
import {
    CreateMusicPieceMutation$data,
    CreateMusicPieceMutation$variables
} from "./__generated__/CreateMusicPieceMutation.graphql";

const mutation = graphql`
    mutation CreateMusicPieceMutation($input: MusicCreatePieceInput!) {
        music_create_piece(input: $input) {
            piece {
                id
                pages {
                    id
                    input_upload_url
                }
            }       
        }
    }
`;

export default function CreateMusicPiece(fileNames: string[]): Promise<CreateMusicPieceMutation$data> {
    const variables: CreateMusicPieceMutation$variables = {
        input: {
            original_file_names: fileNames
        }
    }
    return perform(mutation, variables)
}
